import api from '../../services/service_login'
import Swal from 'sweetalert2'

export default {
  data () {
    const commit = process.env.GIT_COMMIT
    const commitDate = process.env.GIT_COMMIT_DATE
    const buildTime = (commit && commitDate) ? (commit + ' @ ' + commitDate) : (commitDate || commit || '-')
    return {
      username: '',
      password: '',
      buildTime: buildTime
    }
  },
  mounted () {
    this.checkUser()
  },
  methods: {
    authen () {
      this.$store.state.isLoading = true
      var obj = {
        username: this.username,
        password: this.password
      }
      api.login(
        obj,
        result => {
          if (result.response === true) {
            sessionStorage.user = JSON.stringify(result.data.users)
            sessionStorage.token = result.data.token
            this.$store.state.token = result.data.token
            this.$store.state.user = result.data.users
            this.$router.push('/')
            this.alert_msg(
              'success',
              'เข้าสู่ระบบ',
              'ยินดีต้อนรับ คุณ ' + this.$store.state.user.fullname
            )
          } else {
            Swal.fire({
              type: 'warning',
              title: 'แจ้งเตือนระบบ',
              html: '<h4>' + result.message + '<h4>'
            })
            this.$router.push('/login')
          }
          this.$store.state.isLoading = false
        },
        error => {
          Swal.fire({
            type: 'warning',
            title: 'แจ้งเตือนระบบ',
            html: '<h3>' + JSON.stringify(error) + '<h3>'
          })
          this.$router.push('/login')
          this.$store.state.isLoading = false
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/login.js